<template>
  <BreadCrumb PageTitle="Modifier bon d'envoie (GLOBAL)" />
  <EditSentNoteGlobal  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditSentNoteGlobal from "@/components/Notes/SentNotes/EditSentNoteGlobal.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditSentNoteGlobalPage",
  components: {
    BreadCrumb,
    EditSentNoteGlobal,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>